import { createContext } from 'react';

export type MessageArgs = Record<string, unknown>;

/**
 * The subset of an ARB `MessageBundle` that components use.
 *
 * Declared locally because `useBundle`/`getBundle` return a structural type rather than the nominal
 * `MessageBundle` interface.
 */
export interface TranslationBundle {
  getMessage: (id: string) => string;
  formatMessage: (id: string, args: MessageArgs) => string;
}

/**
 * Holds the already-resolved default bundle so `useTranslation` can expose a synchronous `t()`.
 * `undefined` means no provider is mounted above the caller.
 */
const DefaultBundleContext = createContext<TranslationBundle | undefined>(
  undefined,
);

export default DefaultBundleContext;
